import React, {useState} from "react";
import { useForm } from "react-hook-form";
import emailjs from "emailjs-com"

const SuccessResult = () => {
  return (
    <div className="d-flex gap-1 text-success">
      <div>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="18"
				height="18"
				fill="currentColor"
				class="bi bi-check-circle-fill"
				viewBox="0 0 16 16">
				<path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
			</svg>
      </div>
      <div>
			<p className="font-size:sm">
				Your message was successfully sent.
			</p>
      </div>
		</div>
	);
}

// const ErrorResult = () => {
//   return (
// 		<div className="d-flex gap-1 text-danger">
// 			<div>
// 				<svg
// 					xmlns="http://www.w3.org/2000/svg"
// 					width="18"
// 					height="18"
// 					fill="currentColor"
// 					class="bi bi-x-circle-fill"
// 					viewBox="0 0 16 16">
// 					<path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
// 				</svg>
// 			</div>
// 			<div>
// 				<p className="font-size:sm">Sorry! Something went wrong. Please try Again.</p>
// 			</div>
// 		</div>
// 	);
// }

const Contact = () => {

  const [result, showResult] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data, e) => {
     e.preventDefault();

			emailjs
				.sendForm(
					"service_68ki23f",
					"template_1nwwvz6",
					e.target,
					"6taXaqkRcQumGuxEA",
				)
				.then(
					(result) => {
						console.log(result.text);
					},
					(error) => {
						console.log(error.text);
					},
				);
    
    e.target.reset();
    console.log("Message submited: " + JSON.stringify(data));

    showResult(true);
  };

  //hide result
  setTimeout(() => {
    showResult(false);
  }, 5000)

  return (
    <>
      <form className="contactform" onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col-12 col-md-6">
            <div className="form-group">
              <input
                {...register("from_name", { required: true })}
                type="text"
                name="from_name"
                placeholder="YOUR NAME"
              />
              {errors.name && errors.name.type === "required" && (
                <span className="invalid-feedback">Name is required</span>
              )}
            </div>
          </div>
          {/* End .col */}

          <div className="col-12 col-md-6">
            <div className="form-group">
              <input
                {...register(
                  "reply_to",
                  {
                    required: "Email is Required",
                    pattern: {
                      value: /\S+@\S+\.\S+/,
                      message: "Entered value does not match email format",
                    },
                  },
                  { required: true }
                )}
                type="email"
                name="reply_to"
                placeholder="YOUR EMAIL"
              />
              {errors.email && (
                <span className="invalid-feedback">{errors.email.message}</span>
              )}
            </div>
          </div>
          {/* End .col */}

          <div className="col-12 col-md-12">
            <div className="form-group">
              <input
                {...register("subject", { required: true })}
                type="text"
                name="subject"
                placeholder="YOUR SUBJECT"
              />
              {errors.subject && (
                <span className="invalid-feedback">Message is required.</span>
              )}
            </div>
          </div>
          {/* End .col */}

          <div className="col-12">
            <div className="form-group">
              <textarea
                {...register("message", { required: true })}
                name="message"
                placeholder="YOUR MESSAGE"
              ></textarea>
              {errors.message && (
                <span className="invalid-feedback">Message is required.</span>
              )}
            </div>
          </div>
          {/* End .col */}

          <div className="col-12">
            <button type="submit" className="button">
              <span className="button-text">Send Message</span>
              <span className="button-icon fa fa-send"></span>
            </button>
          </div>
          {/* End .col */}

          {/* Message  */}
          <div className="mt-3">
            {result ? <SuccessResult /> : null}
          </div>
          {/* End Message   */}
        </div>
      </form>

      {/* End contact */}
    </>
  );
};

export default Contact;
